import { useState } from "react";
import Web3 from "web3";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import { MintingABINew } from "../../ABIs/MintingABI_new";

const useBuyBulkNfts = () => {
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient(); 

  const buyBulkItems = async (nftIds, totalPrice,gasPrice, onSuccess, ) => {
    setLoading(true);

    try {
      if (typeof window.ethereum === "undefined") {
        throw new Error("MetaMask is not installed. Please install it to continue.");
      }

      const web3 = new Web3(window.ethereum);
      await window.ethereum.request({ method: "eth_requestAccounts" });

      const accounts = await web3.eth.getAccounts();
      const userAddress = accounts[0];

      const MintingInstance = new web3.eth.Contract(MintingABINew, process.env.REACT_APP_CONTRACT_ADDRESS);
      if (!MintingInstance) {
        throw new Error("MintingInstance is not initialized properly");
      }

      const weiPrice = web3.utils.toWei(totalPrice.toString(), "ether");

      const response = await MintingInstance.methods.bulkMint(nftIds).send({
        from: userAddress,
        value: weiPrice,
      //  gasPrice: Number(gasPrice),

      });

      toast.success("NFTs purchased successfully!");

      if (onSuccess) onSuccess(response); 
      await queryClient.invalidateQueries(["Nft"]); 

      return response;
    } catch (error) {
      toast.error("Transaction Failed.");
     return
    } finally {
      setLoading(false);
    }
  };

  return { buyBulkItems, loading };
};

export default useBuyBulkNfts;
